<template>
<div>
	<!-- <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading> -->
	<!-- <div v-if="balancetransfer">
		<change-wallet-currency></change-wallet-currency>
	</div> -->
    <div class="row">
    	<div class="col-12">
            <ul class="fixedMiddleHeaderTab d-flex align-items-center holderCss">
                <li :class="(tab == 0 || tab == 1 || tab == 2 || tab == 3)? 'active': ''" v-on:click.prevent="tab = 0"><a href="#">{{$t('Wallet_Wallet')}}</a></li>
                <li :class="tab == 6? 'active': ''" v-on:click.prevent="tab = 6"><a href="#">{{$t('Wallet_Loyalty_Points')}}</a></li>
            </ul> 
        </div>
       
        <app-wallet-detail :callFrom="'wallet'"  v-if="tab == 0"></app-wallet-detail>
        <div class="col-12"  v-if="tab == 1">
	        <app-deposit :callFrom="'wallet'" :callFromKey="walletId"></app-deposit>
	    </div>
	    <div class="col-12" v-if="tab == 2">
	    	<app-withdraw :callFrom="'wallet'" :callFromKey="walletId"></app-withdraw>
	    </div>
        <div class="col-12" v-if="tab == 3">
            <app-internal-transfer :callFrom="'wallet'" :callFromKey="walletId"></app-internal-transfer>
        </div>
	    <!-- <div class="col-12" v-if="tab == 4">
	    	<appInternalTransfer></appInternalTransfer>
	    	<h2 class="mb-3">Transaction History</h2>
			<div class="inMiddle-area table-responsive">
                <table class="table pmmTable">
                    <thead>
                        <tr>
							<th>Date</th>
							<th>Type</th>
							<th>From</th>
							<th>Το</th>
							<th>Amount</th>
							<th>Fee</th>
							<th>Total</th>
							<th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                    	<tr>
                    		<td>2021.05.14</td>
                    		<td>Transfer</td>
                    		<td>Wallet 1730109</td>
                    		<td>Account 30340508</td>
                    		<td>1.00 EUR</td>
                    		<td>1.00 EUR</td>
                    		<td>1.00 EUR</td>
                    		<td>
                    			<span class="alert alert-success">Complete</span>
                    		</td>
                    	</tr>
                    	<tr>
                    		<td>2021.05.14</td>
                    		<td>Transfer</td>
                    		<td>Wallet 1730109</td>
                    		<td>Account 30340508</td>
                    		<td>1.00 EUR</td>
                    		<td>1.00 EUR</td>
                    		<td>1.00 EUR</td>
                    		<td>
                    			<span class="alert alert-danger">Failed</span>
                    		</td>
                    	</tr>
                    	<tr>
                    		<td>2021.05.14</td>
                    		<td>Transfer</td>
                    		<td>Wallet 1730109</td>
                    		<td>Account 30340508</td>
                    		<td>1.00 EUR</td>
                    		<td>1.00 EUR</td>
                    		<td>1.00 EUR</td>
                    		<td>
                    			<span class="alert alert-warning">Pending</span>
                    		</td>
                    	</tr>
                    	<tr>
                    		<td>2021.05.14</td>
                    		<td>Transfer</td>
                    		<td>Wallet 1730109</td>
                    		<td>Account 30340508</td>
                    		<td>1.00 EUR</td>
                    		<td>1.00 EUR</td>
                    		<td>1.00 EUR</td>
                    		<td>
                    			<span class="alert alert-success">Complete</span>
                    		</td>
                    	</tr>
                    	<tr>
                    		<td>2021.05.14</td>
                    		<td>Transfer</td>
                    		<td>Wallet 1730109</td>
                    		<td>Account 30340508</td>
                    		<td>1.00 EUR</td>
                    		<td>1.00 EUR</td>
                    		<td>1.00 EUR</td>
                    		<td>
                    			<span class="alert alert-success">Complete</span>
                    		</td>
                    	</tr>
                    	<tr>
                    		<td>2021.05.14</td>
                    		<td>Transfer</td>
                    		<td>Wallet 1730109</td>
                    		<td>Account 30340508</td>
                    		<td>1.00 EUR</td>
                    		<td>1.00 EUR</td>
                    		<td>1.00 EUR</td>
                    		<td>
                    			<span class="alert alert-success">Complete</span>
                    		</td>
                    	</tr>
                    </tbody>
                </table>
            </div>
	    </div>
	    <div class="col-12" v-if="tab == 5">
	    	<h3 class="my-3">Transaction History</h3>
			<div class="inMiddle-area table-responsive">
                <table class="table pmmTable">
                    <thead>
                        <tr>
							<th>Date</th>
							<th>Type</th>
							<th>From</th>
							<th>Το</th>
							<th>Amount</th>
							<th>Fee</th>
							<th>Total</th>
							<th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                    	<tr>
                    		<td>2021.05.14</td>
                    		<td>Transfer</td>
                    		<td>Wallet 1730109</td>
                    		<td>Account 30340508</td>
                    		<td>1.00 EUR</td>
                    		<td>1.00 EUR</td>
                    		<td>1.00 EUR</td>
                    		<td>
                    			<span class="alert alert-success">Complete</span>
                    		</td>
                    	</tr>
                    	<tr>
                    		<td>2021.05.14</td>
                    		<td>Transfer</td>
                    		<td>Wallet 1730109</td>
                    		<td>Account 30340508</td>
                    		<td>1.00 EUR</td>
                    		<td>1.00 EUR</td>
                    		<td>1.00 EUR</td>
                    		<td>
                    			<span class="alert alert-danger">Failed</span>
                    		</td>
                    	</tr>
                    	<tr>
                    		<td>2021.05.14</td>
                    		<td>Transfer</td>
                    		<td>Wallet 1730109</td>
                    		<td>Account 30340508</td>
                    		<td>1.00 EUR</td>
                    		<td>1.00 EUR</td>
                    		<td>1.00 EUR</td>
                    		<td>
                    			<span class="alert alert-warning">Pending</span>
                    		</td>
                    	</tr>
                    	<tr>
                    		<td>2021.05.14</td>
                    		<td>Transfer</td>
                    		<td>Wallet 1730109</td>
                    		<td>Account 30340508</td>
                    		<td>1.00 EUR</td>
                    		<td>1.00 EUR</td>
                    		<td>1.00 EUR</td>
                    		<td>
                    			<span class="alert alert-success">Complete</span>
                    		</td>
                    	</tr>
                    	<tr>
                    		<td>2021.05.14</td>
                    		<td>Transfer</td>
                    		<td>Wallet 1730109</td>
                    		<td>Account 30340508</td>
                    		<td>1.00 EUR</td>
                    		<td>1.00 EUR</td>
                    		<td>1.00 EUR</td>
                    		<td>
                    			<span class="alert alert-success">Complete</span>
                    		</td>
                    	</tr>
                    	<tr>
                    		<td>2021.05.14</td>
                    		<td>Transfer</td>
                    		<td>Wallet 1730109</td>
                    		<td>Account 30340508</td>
                    		<td>1.00 EUR</td>
                    		<td>1.00 EUR</td>
                    		<td>1.00 EUR</td>
                    		<td>
                    			<span class="alert alert-success">Complete</span>
                    		</td>
                    	</tr>
                    </tbody>
                </table>
            </div>
	    </div> -->
	    <div class="col-12"  v-if="tab == 6">
	    	<loyalty-points/>
	    </div>
    </div>
</div>
</template>
<script>
    import withdraw from '../withdrawal/withdrawal_wallet'
    import deposit from '../deposit/deposit_wallet'
    import wallet_detail from './wallet_detail'
    import internal_transfer_wallet from '../manageAccounts/internal_transfer_wallet'
    import loyalty_points from './loyalty-points'
    export default {
        name: 'Wallet',
        data() {
            return {
                col_span : 9,
                tab : 0,
                // balancetransfer : false,
                loaderFuncRun : '1',
                walletId : '',
                pageLoader : false
            }
        },
		watch:{
			tab(val){
				$(".mainContent").animate({ scrollTop: 0 }, "fast");
			}
		},
		components:{
			appWithdraw : withdraw,
			appDeposit : deposit,
			loyaltyPoints : loyalty_points,
			appWalletDetail : wallet_detail,
            appInternalTransfer : internal_transfer_wallet,
		},
		methods:{
			changeTab(getTab){
				this.tab = getTab
			}
		},
		created(){
            if(this.$route.params.Section == 'loyality-point'){
                this.tab = 6
            }
            
        }
      
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/wallet/wallet.vue